import { type UseQueryResult, useQuery } from 'react-query';
import { CsBrokerTradeToolService } from '../../services/wealthlane-award-services/services/CsBrokerTradeToolService';

const useGetCsReasonCodes = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<Array<{ label: string; value: string }> | undefined, unknown> => {
  return useQuery(['getCsReasonCodes'], async () => {
    return await handleRequest(
      CsBrokerTradeToolService.getApiAwardApiAppCsBrokerTradeToolReasonCodes()
    );
  });
};

export default useGetCsReasonCodes;
